import { MarketplaceAPI } from "../../../marketplace";
import { AI_INSIGHTS_TOOL_SLUG } from "../../domain/types";

/**
 * Adoption lookup for the AI Insights tool.
 *
 * Deliberately a thin wrapper over the marketplace client from #184 instead of a
 * second HTTP client: adoption state has a single source of truth.
 */
export const AiInsightsAdoptionAPI = {
    isAdopted: async (): Promise<boolean> => {
        const { data } = await MarketplaceAPI.listAdopted();
        return data.some((tool) => tool.slug === AI_INSIGHTS_TOOL_SLUG);
    },
};
